module.exports = function() {
  return new Worker(__webpack_public_path__ + "a69766707a11d2ac6b6e.worker.js");
};